export async function getRoleUsers(id) {
  try {
    const response = await fetch(
      `/internal-api/auth/access/user?userId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка: ", error);
  }
}
